<template>
    <h4>Designed By <a href="https://in.linkedin.com/in/shrey-vasani-254019159" target="_blank"> Shrey Vasani </a>|| All Data Provided By <a href="https://openweathermap.org/api" target="_blank">Openweathermap Api</a></h4>
</template>

<script>
export default {
    name:"Footer",
}
</script>

<style>
    h4{
        color: white;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
        background: rgba(255, 255, 255, 0.4);
    }
    a{
        text-decoration: none;
        color: white;
    }
</style>